<template>
  <div id="app"
       class="container-fluid p-0"
       role="grid">
    <header id="bar-top"
            class="fixed-top bg-light w-100 p-0"
            role="grid">
      <div id="banner"
           class="center w-100 px-3 px-3 d-flex justify-content-between align-items-center position-relative">
        <router-link
          class="parallelogramRight d-none d-md-flex align-items-center"
          :to="{ name: 'IngenierieConseilPatrimoniaux' }">
          <img id="bannerCGCourtage"
            src="../../assets/images/logo-CGcourtage.svg"
            alt="bannière CG Courtage">
        </router-link>
        <router-link id="compteLink"
                     class="align-self-end position-absolute"
                     :to="{ name: 'Connexion' }">
          <img id="logoMonCompte"
               src="../../assets/images/bt-espace-client.svg"
               alt="logo mon compte">
        </router-link>
        <div class="d-flex flex-column flex-md-row align-items-center"
             role="grid">
          <img id="bannerTollusImmo"
               class="bannerTollusImmo d-none d-md-inline-block"
               src="../../assets/images/logo-tolusimmo.svg"
               alt="bannière Tollus Immo">
          <div class="d-inline-block align-middle ml-0 ml-md-3"
               role="grid">
            <a href="tel:+33561862927"
               class="d-block text-secondary font-weight-bold mb-0">05 61 86 29 27</a>
            <a href="mailto:contact@tolus-immo.com"
               class="d-block text-dark"
               id="contactTI">contact@tolus-immo.com</a>
          </div>
        </div>
      </div>
      <b-navbar toggleable="md"
                type="dark"
                class="px-0"
                variant="dark py-1">
        <b-navbar-toggle target="top-nav-collapse"></b-navbar-toggle>
        <b-collapse id="top-nav-collapse"
                    class="center"
                    is-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'Home' }"
                        exact-active-class="active"
                        class="text-uppercase">Accueil</b-nav-item>
            <b-nav-item :to="{ name: 'Achat', params: {typeSearched: 'bien'} }"
                        active-class="active"
                        :active="this.$route.name === 'Achat'"
                        class="text-uppercase">Achat</b-nav-item>
            <b-nav-item :to="{ name: 'Vente' }"
                        exact-active-class="active"
                        class="text-uppercase">Vente</b-nav-item>
            <b-nav-item :to="{ name: 'Investir' }"
                        exact-active-class="active"
                        class="text-uppercase">Investir</b-nav-item>
            <b-nav-item :to="{ name: 'InfosTolus' }"
                        exact-active-class="active"
                        class="text-uppercase">Focus</b-nav-item>
            <b-nav-item :to="{ name: 'Agence' }"
                        exact-active-class="active"
                        class="text-uppercase text-nowrap">Notre Agence</b-nav-item>
            <b-nav-item :to="{ name: 'ContactTI' }"
                        exact-active-class="active"
                        class="text-uppercase">Contact</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <main class="row w-100 h-100 m-0 main-row d-flex flex-nowrap"
          role="grid">
      <router-view />
    </main>
    <footer id="bar-bottom">
      <div id="footer-banner"
           class="col px-0 bg-secondary">
        <ul class="row center list-unstyled d-flex flex-column flex-sm-row justify-content-center w-100 px-3 px-sm-0">
          <li class="d-flex flex-column justify-content-between align-items-center align-items-md-start border-right px-3 py-3 py-sm-0 mx-3 mx-sm-0">
            <img src="../../assets/images/logo-tolusimmo.svg"
                 alt="bannière Tollus Immo"
                 class="bannerTollusImmo">
            <a class="openSans-bold nav-link text-primary small-ls h4"
               href="https://www.facebook.com/tolusimmobilier/"
               target="_blank"><u>Suivez-nous sur</u><img src="../../assets/images/picto-facebook.svg" alt="logo FaceBook" class="ml-3"></a>
          </li>
          <li
              class="d-flex flex-column justify-content-between px-3 py-3 py-sm-0 mb-3 mb-sm-0 mx-3 mx-sm-0">
            <p class="bold text-light mb-0 mb-md-1 mb-lg-3">Vous avez une question ou une suggestion ?</p>
            <p class="text-light mb-0 mb-md-1 mb-lg-3">Nos équipes se tiennent à votre disposition pour toutes
              interrogations sur nos biens
              et services.</p>
              <div id="contactUs" class="bg-light">
                <b-button
                  :to="{ name: 'ContactTI' }"
                  squared
                  variant="outline-secondary w-100">
                  Contactez-nous
                </b-button>
            </div>
          </li>
        </ul>
      </div>
      <b-navbar id="bar-bottom"
                toggleable="md"
                type="dark"
                variant="col-12 bg-dark py-1">
        <b-navbar-toggle target="bottom-nav-collapse"></b-navbar-toggle>
        <b-collapse id="bottom-nav-collapse"
                    class="center"
                    is-nav>
          <b-navbar-nav>
            <b-nav-item :to="{ name: 'Bareme' }"
                        class="text-primary">Barème des honoraires</b-nav-item>
            <b-nav-item :to="{ name: 'Mentions' }"
                        class="text-primary">Mentions légales</b-nav-item>
            <b-nav-item :to="{ name: 'Agence' }"
                        class="text-primary">À propos de nous</b-nav-item>
            <b-nav-item :to="{ name: 'ContactTI' }"
                        class="text-primary">Nous contacter</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavbarPlugin,
  ButtonPlugin
} from 'bootstrap-vue'

Vue.use(NavbarPlugin)
Vue.use(ButtonPlugin)

export default {
  name: 'TolusImmo',
  data () {
    return {
      email: null
    }
  }
}
</script>

<style lang="scss" scoped>

$heigtBarTop: 7.8rem;
$heightNavBar: 3rem;

.bannerTollusImmo {
  width: auto;
  height: 4.5rem !important;
}


#bar-top {

  .parallelogramRight {
    height: 100% !important;
    box-shadow: 0px 3px 6px var(--dark);
    transform: skew(-25deg);
    padding: 0 2rem !important;
    #bannerCGCourtage {
      filter: grayscale(1);
      transform: skew(25deg);
      width: auto;
      height: 4.5rem !important;
    }
    figcaption {
      transform: skew(25deg);
    }
    figcaption::after {
      content: '\2303';
      display: inline-block;
      vertical-align: middle !important;
      font-weight: bolder !important;
      font-size: 1.4rem !important;
      transform: rotate(90deg);
      color: var(--primary)
    }
  }
  .parallelogramRight:hover {
    #bannerCGCourtage {
      filter: grayscale(0);
    }
  }

  #banner {
    width: 100%;
    #compteLink {
      transform: translateX(-50%) !important;
      left: 50% !important;
    }
  }

  #logoMonCompte {
    width: auto;
    height: 5rem;
  }

  .navbar {
    width: 100% !important;

    .navbar-collapse{
      justify-content: center;
    }
    .nav-link {
      position: relative;
      padding: 0 2rem !important;
      height: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      line-height: 1rem;
      color: white;
    }
    .nav-link:hover {
      color: var(--secondary) !important;
    }
    .active{
      text-decoration: underline;
      text-decoration-color: var(--secondary);
    }

    .nav-item:not(:last-of-type) {
      border-right: 1px solid var(--light) !important;
    }
  }
}

#bar-bottom {
  #footer-banner {
    ul {
      padding-bottom: 4.5rem !important;
      padding-top: 3.2rem !important;

      li {
        height: 12rem !important;
        width: 30% !important;
      }
    }

    #contactUs {
      width: 11rem !important;
    }

    #emailToAlert {
      padding: 0.25rem !important;
    }

    #emailToAlert::placeholder {
      color: var(--secondary);
    }
  }

  .navbar {
    width: 100% !important;

    .navbar-nav {
      margin: 0 auto !important;
      max-width: 100% !important;

      .nav-item {
        white-space: nowrap !important;

        .nav-link {
          position: relative;
          color: var(--primary) !important;
          bottom: 0.4rem !important;
          padding: 0 2rem;
        }
      }

      .nav-item:not(:last-of-type) {
        border-right: 1px solid var(--primary) !important;
      }
    }
  }
}

#navbarNavBottom ul li.nav-item a {
  padding: 1rem !important;
  margin: 0 !important;
}

main {
  padding: $heigtBarTop 0 0 0 !important;
}

@media (max-width: 575px) {

  #navbarNavBottom ul li.nav-item a.border-right {
    border-right: none !important;
    border-bottom: 1px solid var(--primary) !important;
  }

  #bar-bottom {
    #footer-banner {
      ul {
        li {
          width: calc(100% - 2rem) !important;
          border-right: none !important;
          border-bottom: 1px solid var(--light) !important;
        }
      }
    }
  }
}

#bar-top {
    height: $heigtBarTop !important;

    #banner {
      height: calc(#{$heigtBarTop} - #{$heightNavBar});
    }
  }

@media (min-width: 576px) {
  #bar-bottom {
    #footer-banner {
      ul {
        li {
          width: 30% !important;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .center {
    max-width: 100%;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  #bar-bottom {
    .navbar-nav {
      .nav-item {
        .nav-link {
          width: 20rem !important;
          margin: 0 auto !important;
          padding-top: 0.4rem !important;
          padding-bottom: 0.4rem !important
        }
      }

      .nav-item:not(:last-of-type) {
        .nav-link {
          border-bottom: 1px solid var(--primary) !important;
        }
      }
    }
  }

  #bar-top {
    .navbar-nav {
      .nav-item {
        .nav-link {
          width: 20rem !important;
          margin: 0 auto !important;
          padding-top: 0.4rem !important;
          padding-bottom: 0.4rem !important
        }
      }

      .nav-item:not(:last-of-type) {
        .nav-link {
          border-bottom: 1px solid var(--gray) !important;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  #bar-top {
    .navbar {
      height: 2.9rem !important;

      .nav-item {
        height: 0.8rem !important;
      }
    }
  }

  #bar-bottom {
    .navbar {
      height: 2.9rem !important;

      .nav-item {
        height: 0.8rem !important;
      }
    }
  }
}

.btn-outline-secondary:hover {
  border-color: #fff !important;
}
@media print {
  footer,
  #compteLink,
  .parallelogramRight {
    display:none !important;
  }
}
</style>
